import { create } from 'zustand';

// Carrito — estado en memoria, no se persiste (se pierde al cerrar la app,
// que es el comportamiento correcto para un carrito de POS)
export const useCartStore = create((set, get) => ({
  items: [],       // [{ product, quantity, unit_price, total }]
  customer: null,  // Customer | null
  discount: 0,     // importe fijo de descuento
  note: '',        // nota libre de la venta

  // ─── Items ───────────────────────────────────────────────────────────────────

  addItem: (product) => {
    const items = get().items;
    const idx   = items.findIndex((i) => i.product._id === product._id);
    if (idx >= 0) {
      const updated = [...items];
      updated[idx] = {
        ...updated[idx],
        quantity:  updated[idx].quantity + 1,
        total:     (updated[idx].quantity + 1) * updated[idx].unit_price,
      };
      set({ items: updated });
    } else {
      set({
        items: [...items, {
          product,
          quantity:   1,
          unit_price: product.price,
          total:      product.price,
        }],
      });
    }
  },

  removeItem: (productId) =>
    set({ items: get().items.filter((i) => i.product._id !== productId) }),

  updateQuantity: (productId, quantity) => {
    if (quantity <= 0) {
      get().removeItem(productId);
      return;
    }
    set({
      items: get().items.map((i) =>
        i.product._id === productId
          ? { ...i, quantity, total: quantity * i.unit_price }
          : i
      ),
    });
  },

  setItemPrice: (productId, price) =>
    set({
      items: get().items.map((i) =>
        i.product._id === productId
          ? { ...i, unit_price: price, total: i.quantity * price }
          : i
      ),
    }),

  clearCart: () => set({ items: [], customer: null, discount: 0, note: '' }),

  // Restore full cart state from a saved tab
  replaceCart: ({ items, customer, discount, note }) =>
    set({ items: items ?? [], customer: customer ?? null, discount: discount ?? 0, note: note ?? '' }),

  // ─── Cliente ─────────────────────────────────────────────────────────────────

  setCustomer: (customer) => set({ customer }),
  clearCustomer: () => set({ customer: null }),

  // ─── Descuento ───────────────────────────────────────────────────────────────

  setDiscount: (amount) => set({ discount: Math.max(0, amount) }),
  setNote: (note) => set({ note }),

  // ─── Totales derivados ────────────────────────────────────────────────────────

  getSubtotal: () => get().items.reduce((acc, i) => acc + i.total, 0),

  getTotal: () => {
    const subtotal = get().getSubtotal();
    return Math.max(0, subtotal - get().discount);
  },

  getItemCount: () => get().items.reduce((acc, i) => acc + i.quantity, 0),
}));
